export enum ROLES {
  ADMIN = 'admin',
  USER = 'user',
  DEMO = 'demo',
}

export type RoleTypes = (typeof ROLES)[keyof typeof ROLES]
